// extracted by mini-css-extract-plugin
export default {"container":"Pq-z","brandName":"Qq-z","productName":"Rq-z","productNamePdpEnhancements":"Sq-z","breakLongProductName":"Tq-z"};